// extracted by mini-css-extract-plugin
export default {"numberInput":"gen-textfield_numberInput__Tm1-N"};